import React from "react";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import i18n from "../translationUtils/i18n";
import frdarklogo from "../res/FireRoverLogo2024_White.png";
import frlightlogo from "../res/FireRoverLogo2023_Black.png";
import { useThemeContext } from '../styles/ThemeContextProvider.jsx';

export function Home() {
  const { mode } = useThemeContext();
  const frLogo = mode === 'dark' 
    ? frdarklogo 
    : frlightlogo;
  return (
    <>
      <Grid
        container
        justifyContent="center" // Center vertically
        alignItems="center" // Center horizontally
        style={{ height: "10%", paddingTop: "5%" }} // Center vertically
      >
        <Typography
          variant="h3"
          alignItems="center"
          fontFamily="Arial, Helvetica, sans-serif">
          {i18n.t('welcometoportal')}
        </Typography>
      </Grid>
      <Grid
        container
        justifyContent="center" // Center vertically
        alignItems="center" // Center horizontally
        style={{ height: "10%", paddingTop: "3%" }} // Center vertically
      >
        <img
          src={frLogo}
          alt="Fire Rover Logo"
          style={{ width: "70%", borderRadius: "5%" }}
        />
      </Grid>
      {i18n.locale === 'en-US' &&
        <Grid
          container
          justifyContent="center" // Center vertically
          alignItems="center" // Center horizontally
          style={{ height: "10%", paddingTop: "3%" }} // Center vertically
        >
          <Typography
            variant="h3"
            alignItems="center"
            fontFamily="Arial, Helvetica, sans-serif">
            {i18n.locale === 'en-US' && i18n.t('customerportal')}
          </Typography>
        </Grid>
      }
    </>
  );
}